class CategoryNavCarousel extends HTMLElement {
  #list = null;
  #prevBtn = null;
  #nextBtn = null;
  #resizeObserver = null;
  #onScroll = () => this.#update();
  #onPrev = () => this.#scroll(-1);
  #onNext = () => this.#scroll(1);

  connectedCallback() {
    this.#list    = this.querySelector('.c-category-nav__list');
    this.#prevBtn = this.querySelector('.c-category-nav__arrow--prev');
    this.#nextBtn = this.querySelector('.c-category-nav__arrow--next');

    if (!this.#list || !this.#prevBtn || !this.#nextBtn) return;

    this.#list.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#prevBtn.addEventListener('click', this.#onPrev);
    this.#nextBtn.addEventListener('click', this.#onNext);

    this.#resizeObserver = new ResizeObserver(() => this.#update());
    this.#resizeObserver.observe(this.#list);

    this.#update();
  }

  disconnectedCallback() {
    this.#list?.removeEventListener('scroll', this.#onScroll);
    this.#prevBtn?.removeEventListener('click', this.#onPrev);
    this.#nextBtn?.removeEventListener('click', this.#onNext);
    this.#resizeObserver?.disconnect();
  }

  #update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.#list;
    const canScroll = scrollWidth > clientWidth + 1;

    this.#prevBtn.disabled = !canScroll || scrollLeft <= 0;
    this.#nextBtn.disabled = !canScroll || scrollLeft + clientWidth >= scrollWidth - 1;
  }

  #scroll(direction) {
    const itemWidth = this.#list.querySelector('.c-category-nav__item')?.offsetWidth ?? 140;
    this.#list.scrollBy({ left: direction * itemWidth, behavior: 'smooth' });
  }
}

customElements.define('category-nav-carousel', CategoryNavCarousel);
